module.exports = __webpack_public_path__ + "media/applicants/icon-interview@2x-507e3591.png";